import { errorMessage, grantWarningsFromError } from '@dataroom/shared';

/** Non-warning error message from a mutation error (409 warnings are handled
 * separately via the advise+acknowledge flow, so those are suppressed here). */
export function plainError(error: unknown): string | null {
  if (grantWarningsFromError(error).length > 0) return null;
  return errorMessage(error);
}

/** The user-facing message for any error (friendly ApiError text, a generic
 * sentence for anything else — never a raw technical message), else null. */
export function apiMessage(error: unknown): string | null {
  return errorMessage(error);
}
